import { getDefaultAutoplayList, getSubseriesAutoplayList } from '../../../api/autoplay';

export default async function (page, props) {
  let { kind } = props;

  // Provera subscription statusa iz localStorage
  const subscriptionStatus = JSON.parse(localStorage.getItem('subscription'));
  if (subscriptionStatus === false) {
    localStorage.removeItem('VODList');
    console.log('Subscription is inactive, skipping API calls.');
    if (page._Column) {
      page._Column.items = [];
    } else {
      page._Column = { items: [] };
    }
    return; // Prekida izvršavanje ukoliko je subscription na false
  }

  switch (kind) {
    case 'movie':
      return getDefaultAutoplayList(props.movieId)
        .then((res) => {
          localStorage.setItem('VODList', JSON.stringify(res.data));
          if (page._Column) {
            page._Column.items = [];
          } else {
            page._Column = { items: [] };
          }
        })
        .catch((error) => {
          console.error('Error fetching default autoplay list:', error);
          localStorage.setItem('VODList', JSON.stringify([])); // Postavi prazan niz u slučaju greške
          if (page._Column) {
            page._Column.items = [];
          } else {
            page._Column = { items: [] };
          }
        });

    case 'series':
      return getSubseriesAutoplayList(props.movieId)
        .then((res) => {
          localStorage.setItem('VODList', JSON.stringify(res.data));
          if (page._Column) {
            page._Column.items = [];
          } else {
            page._Column = { items: [] };
          }
        })
        .catch((error) => {
          console.error('Error fetching subseries autoplay list:', error);
          localStorage.setItem('VODList', JSON.stringify([])); // Postavi prazan niz u slučaju greške
          if (page._Column) {
            page._Column.items = [];
          } else {
            page._Column = { items: [] };
          }
        });

    case 'all':
      localStorage.removeItem('VODList');
      if (page._Column) {
        page._Column.items = [];
      } else {
        page._Column = { items: [] };
      }
      break;
  }
}
